export const GrainOverlay = () => {
  return <div className="grain-overlay" aria-hidden="true" />;
};
